import React, {useState} from "react";
import {apiHelper, baseUrl} from "helpers/util";

export default function FolkGuideWiseReport({data, getTodayDate, onClose}) {
    const [isOpen, setIsOpen] = useState(!!data);

    const closeReport = () => {
        setIsOpen(false);
        if (onClose) onClose();
    };

    const guideTotals = data ? data.guideHash : {};

    const maxValue = Math.max(...Object.values(guideTotals), 1);

    return (
        <>
            {data && isOpen && (
                <div
                    style={{
                        position: "relative",
                        background: "#f8f9fa",
                        padding: "20px",
                        borderRadius: "12px",
                        border: "1px solid #dee2e6",
                        maxWidth: "100%",
                        margin: "20px auto 0",
                        boxSizing: "border-box",
                        overflow: "hidden"
                    }}
                >
                    <button
                        onClick={closeReport}
                        style={{
                            position: "absolute",
                            top: "15px",
                            right: "15px",
                            border: "none",
                            background: "#ffffff",
                            color: "#6c757d",
                            borderRadius: "50%",
                            width: "32px",
                            height: "32px",
                            cursor: "pointer",
                            fontSize: "18px",
                            fontWeight: "bold",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = "#f8f9fa";
                            e.target.style.color = "#dc3545";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = "#ffffff";
                            e.target.style.color = "#6c757d";
                        }}
                    >
                        ×
                    </button>

                    <h3 style={{marginBottom: "5px"}}>📊 FOLK Guide Wise Attendance</h3>
                    <div style={{color: "#666", marginBottom: "20px"}}>{getTodayDate()}</div>

                    <div
                        style={{
                            display: "flex",
                            alignItems: "flex-end",
                            gap: "8px",
                            height: "250px",
                            padding: "15px",
                            background: "#fff",
                            borderRadius: "8px",
                            border: "1px solid #e9ecef",
                            overflowX: "auto",
                        }}
                    >
                        {["SHSD", "PDKD", "BRBD", "VKGD", "SKBD", "RUVD", "PRMD", "SNKD", "RJMD", "KSBD", "NYCD", "RKGD"]
                            .filter(guide => guideTotals[guide])
                            .map((guide, index) => {
                                const count = guideTotals[guide];
                                const height = Math.max((count / maxValue) * 200, 20);
                                const colors = ["#0d6efd", "#198754", "#dc3545", "#ffc107", "#c14295ff", "#fd7e14", "#c92055ff"];
                                const color = colors[index % colors.length];

                                return (
                                    <div
                                        key={guide}
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            width: "25%",
                                        }}
                                    >
                                        <div style={{fontWeight: "bold", fontSize: "12px"}}>{count}</div>

                                        <div
                                            style={{
                                                width: "100%",
                                                height: `${height}px`,
                                                backgroundColor: color,
                                                borderRadius: "6px 6px 0 0",
                                            }}
                                        />

                                        <div
                                            style={{
                                                marginTop: "6px",
                                                fontSize: "12px",
                                                fontWeight: "600",
                                                textAlign: "center",
                                            }}
                                        >
                                            {guide}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>

                    <div
                        style={{
                            marginTop: "15px",
                            padding: "10px",
                            background: "#d1ecf1",
                            borderRadius: "6px",
                            fontWeight: "bold",
                            color: "#0c5460",
                        }}
                    >
                        Overall Total: {data.overallTotal}
                    </div>
                </div>
            )}
        </>
    );
}